import React from "react";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import {
    faMobileAlt
  } from "@fortawesome/fontawesome-free-solid";

const TurnDeviceDialog = () => {
    return (
        <div className="black-dialog-box">
            <div className="vwrapper-container">
                <div className="vwrapper v100">
                    <FontAwesomeIcon icon={faMobileAlt} className="animation-rotate" size="5x"/>
                    <p>Please turn your device</p>
                </div>
            </div>
        </div>
    );
}

export default TurnDeviceDialog;


// WEBPACK FOOTER //
// ./src/components/TurnDeviceDialog.js